import { atom } from 'jotai'

import { SidePanelState } from 'src/types'

type Input = {
  // NOTE: isOpenedがtrueの場合は必ずstateが存在する。isOpenedがfalseの場合はstateがnullになる
  state: SidePanelState | null
}

const storeValues = atom<Input>({
  state: null,
})
export const sidePanelStore = { state: storeValues } as const
